import 'core-js/fn/array/every';
import 'core-js/fn/array/find';
import 'core-js/fn/array/from';
import 'core-js/fn/array/includes';
import 'core-js/fn/object/assign';
import 'core-js/fn/object/entries';
import 'core-js/fn/object/values';
import 'core-js/fn/map'; // todo weak-map
import 'core-js/fn/set'; // todo weak-set
import 'core-js/fn/symbol';
import 'core-js/fn/string/ends-with';
import 'core-js/fn/string/includes';
import 'core-js/fn/string/starts-with';
import 'core-js/fn/number/is-nan';
import 'core-js/fn/string/repeat';
import 'core-js/fn/array/find-index';
import 'core-js/fn/math/sign';
import 'core-js/fn/math/trunc';
import 'svgxuse';
import 'whatwg-fetch';

if (!window.location.origin) {
  const { protocol, hostname, port } = window.location;
  window.location.origin = `${protocol}//${hostname}${port ? `:${port}` : ''}`;
}

if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}



// WEBPACK FOOTER //
// ./node_modules/cigna-frontend/js/polyfill.js